import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

export const Product = ({ data }) => {
  const { id } = useParams();
  const history = useHistory();

  // Estado para el modal
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false); // Estado para mostrar un spinner de carga

  // Función para regresar a la posición exacta de la página principal
  const handleBack = () => {
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    history.push("/");

    setTimeout(() => {
      if (scrollPosition) {
        window.scrollTo({ top: parseInt(scrollPosition, 10), behavior: "smooth" });
      }
      sessionStorage.removeItem("scrollPosition");
    }, 200);
  };

  if (!data || !data.ProductSection || !data.ProductSection.products) {
    return <p style={{ textAlign: "center", fontSize: "20px", color: "#fff" }}>Cargando productos...</p>;
  }

  const product = data.ProductSection.products.find((prod) => prod.id === id);

  if (!product) {
    return <p style={{ textAlign: "center", fontSize: "20px", color: "#fff" }}>Producto no encontrado.</p>;
  }

  // 📌 Función para enviar datos a la API
  const handleSubmit = async () => {
    if (!name || !email) {
      alert("❌ Por favor, completa todos los campos.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("vivebackend-a5hdfhhtbphgd4ed.canadacentral-01.azurewebsites.net/api/chargeClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ProductId: product.id, // Enviar el ID del producto
          ClientName: name,
          ClientEmail: email,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        alert(`✅ ${product.textModalA}, ${name}! ${product.textModalB} ${email}.`);
        setShowModal(false);
        setName("");
        setEmail("");
      } else {
        alert(`❌ Error: ${result.message || "No se pudo completar la solicitud."}`);
      }
    } catch (error) {
      alert("❌ Ocurrió un error al enviar la solicitud.");
      console.error("Error:", error);
    }

    setLoading(false);
  };

  // 📌 Función para compartir el producto en redes sociales
  const shareProduct = (productId, title) => {
    const productUrl = `${window.location.origin}/product/${productId}`;

    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: `${product.textShare} ${title}! 🚀`,
          url: productUrl,
        })
        .catch((error) => console.log(product.errorShare, error));
    } else {
      navigator.clipboard.writeText(productUrl)
        .then(() => alert(`✅ ${product.copyDone}`))
        .catch(() => alert(`❌ ${product.copyFail}`));
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "80px auto" }}>
      {/* Botón de Retroceso */}
      <button
        onClick={handleBack}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 15px",
          backgroundColor: "#0A3A2C",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "16px",
          marginBottom: "20px",
        }}
      >
        <i className="fas fa-arrow-left"></i> Back
      </button>

      <h1 style={{ textAlign: "center", fontSize: "32px", fontWeight: "bold", marginBottom: "40px", color: "#fff" }}>
        {product.title}
      </h1>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          position: "relative",
          padding: "20px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f9f9f9" }}>
          <img src={product.image} alt={product.title} style={{ maxWidth: "100%", maxHeight: "300px", objectFit: "contain" }} />
        </div>

        <div style={{ padding: "30px", display: "flex", flexDirection: "column" }}>
          <h2 style={{ fontSize: "26px", fontWeight: "bold", marginBottom: "15px", color: "#0A3A2C" }}>{product.title}</h2>
          <p style={{ fontSize: "20px", marginBottom: "15px", lineHeight: "1.5", color: "#0A3A2C" }}>
            {product.description}
          </p>
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {product.features.map((feature, i) => (
              <li key={i} style={{ color: "#0A3A2C", marginBottom: "10px" }}>
                <i className="fas fa-check-circle"></i> {feature}
              </li>
            ))}
          </ul>

          {/* Botón de Comprar - Abre el Modal */}
          <button
            style={{
              padding: "12px 20px",
              backgroundColor: "#0A3A2C",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
              marginTop: "10px",
            }}
            onClick={() => setShowModal(true)}
          >
            {product.buttonText}
          </button>

          {/* Botón de Compartir */}
          <button
            style={{
              padding: "10px",
              backgroundColor: "transparent",
              border: "1px solid #0A3A2C",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
              color: "#0A3A2C",
              marginTop: "10px",
            }}
            onClick={() => shareProduct(product.id, product.title)}
          >
            <i className="fas fa-share-alt"></i> {product.share}
          </button>
        </div>
      </div>

      {/* MODAL DE PRE-COMPRA */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              width: "400px",
              textAlign: "center",
            }}
          >
            <h2 style={{ color: "#0A3A2C" }}>{product.titleModal}</h2>
            <p>{product.subTitleModal}</p>

            <input style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }} type="text" placeholder={product.placeHolderName} value={name} onChange={(e) => setName(e.target.value)} />
            <input style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }} type="email" placeholder={product.placeHolderEmail} value={email} onChange={(e) => setEmail(e.target.value)} />

            <button style={{
                  backgroundColor: "#0A3A2C",
                  color: "#fff",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  flex: 1,
                  marginRight: "5px",
                }} onClick={handleSubmit} disabled={loading}>{loading ? "Enviando..." : product.ButtonSend}</button>
            <button style={{
                  backgroundColor: "#ccc",
                  color: "#000",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  flex: 1,
                  marginLeft: "5px",
                }} onClick={() => setShowModal(false)}>{product.ButtonClose}</button>
          </div>
        </div>
      )}
    </div>
  );
};
